import { DOCUMENT } from '@angular/common';
import {
  SimpleChanges,
  OnChanges,
  OnInit,
  Component,
  Output,
  EventEmitter,
  Input,
  Inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { useLearnerCx } from '@degreed/apollo-angular';

@Component({
    selector: 'dgx-page-save-footer',
    templateUrl: './page-save-footer.component.html',
    styleUrls: ['./page-save-footer.component.scss'],
    standalone: false
})
export class PageSaveFooterComponent implements OnChanges, OnInit {
  public useApollo = useLearnerCx();
  public i18n = this.translate.instant([
    'Core_Cancel',
    'Core_SaveChanges',
    'Core_Loading',
  ]);
  public isSubmitting = false;
  @Input() public showFooter: boolean;
  @Input() public saveDisabled: boolean = false;
  @Output() public save = new EventEmitter();
  @Output() public discard = new EventEmitter();

  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  public ngOnInit() {
    return;
  }
  public ngOnChanges(changes: SimpleChanges) {
    // hide the feedback icon while the footer is shown
    if (changes && changes.showFooter) {
      const jsFeedback = this.document.querySelector('.js-feedback');
      if (changes.showFooter.currentValue === true) {
        this.isSubmitting = false;
        jsFeedback?.classList.add('hide');
      } else {
        jsFeedback?.classList.add('show');
      }
    }
  }
  public saveChanges() {
    this.isSubmitting = true;
    this.save.emit();
  }

  public discardChanges() {
    this.discard.emit();
  }
}
